{
  "shell": {
    "logo_alt": "Rhemn",
    "navUpgrade": "Naik taraf",
    "navBilling": "Pengebilan"
  },
  "upgrade": {
    "badge": "Rhemn Pro",
    "title": "Tab anda. <em>Zikir</em> anda.<br />Diperhalus.",
    "subtitle": "Setiap ciri yang anda perlukan untuk hari yang lebih bermakna — daripada waktu solat dan renungan ayat AI hingga cuaca dan tugasan keutamaan — dalam satu tab baharu yang tenang dan indah.",
    "comparison_aria": "Perbandingan pelan",
    "free": {
      "tierLabel": "Semasa",
      "tierName": "Percuma",
      "freeLabel": "Sentiasa percuma",
      "list_aria": "Ciri pelan percuma"
    },
    "pro": {
      "list_aria": "Ciri pelan Pro",
      "tierLabel": "Naik taraf ke",
      "tierName": "Pro",
      "pricePeriod": "/ bulan",
      "priceAlt": "atau $39.99 / tahun"
    },
    "freeFeatures": {
      "clockDate": "Paparan jam & tarikh",
      "verseOfDay": "Ayat Quran harian",
      "dailyBackground": "Foto latar belakang harian",
      "qiblaCompass": "Kompas kiblat",
      "basicTasks": "Tugasan asas"
    },
    "proFeatures": {
      "weatherForecast": "Ramalan cuaca 5 hari",
      "verseFavorites": "Simpan & lihat ayat kegemaran",
      "notesAi": "Nota dengan analisis AI",
      "priorityTasks": "Pengurusan tugasan keutamaan",
      "verseReflection": "Renungan ayat dengan AI"
    },
    "plans": {
      "monthly": {
        "label": "Bulanan",
        "price": "$4.99",
        "period": "/ bulan",
        "note": "Dibilkan bulanan"
      },
      "yearly": {
        "label": "Tahunan",
        "price": "$39.99",
        "period": "/ tahun",
        "note": "Dua bulan percuma",
        "badge": "Jimat 33%"
      }
    },
    "pricingTitle": "Rhemn Pro",
    "pricingDesc": "Batal bila-bila masa. Akses anda berterusan hingga akhir tempoh pengebilan tanpa caj separa.",
    "billingPeriod_aria": "Tempoh pengebilan",
    "cta": "Teruskan ke pembayaran selamat",
    "ctaLoading": "Mengalihkan ke pembayaran…",
    "promoManual": "Masukkan kod {{code}} di halaman seterusnya untuk mendapatkan diskaun anda.",
    "signingUpAs": "Mendaftar sebagai {{account}}",
    "trustSignals_aria": "Isyarat kepercayaan",
    "reassurance": {
      "secureCheckout": "Pembayaran selamat melalui Stripe",
      "cancelAnytime": "Batal bila-bila masa, tanpa soalan",
      "accessUntilEnd": "Akses hingga akhir tempoh"
    },
    "errors": {
      "restoreSession": "Tidak dapat memulihkan sesi anda. Sila cuba lagi daripada sambungan.",
      "checkoutFailed": "Gagal memulakan pembayaran. Sila cuba lagi."
    }
  },
  "upgradeStatus": {
    "unlockedFeatures_aria": "Ciri yang dibuka",
    "unlockedFeatures": {
      "weatherForecast": "Ramalan cuaca 5 hari",
      "verseFavorites": "Simpan dan lihat ayat kegemaran",
      "notesAi": "Nota dengan analisis AI",
      "priorityTasks": "Pengurusan tugasan keutamaan",
      "verseReflection": "Renungan ayat dengan AI"
    },
    "success": {
      "title": "Selamat datang ke Pro",
      "desc": "Langganan anda aktif. Kembali ke sambungan untuk menemui semua ciri Pro menanti anda.",
      "viewBilling": "Lihat butiran pengebilan",
      "closeTab": "Tutup tab ini"
    },
    "cancel": {
      "title": "Pembayaran dibatalkan",
      "desc": "Jangan risau — pelan anda tidak diubah dan anda tidak dicaj. Anda boleh naik taraf bila-bila masa anda bersedia.",
      "backToUpgrade": "Kembali ke naik taraf",
      "returnToExtension": "Kembali ke sambungan"
    }
  },
  "billing": {
    "title": "Pengebilan",
    "subtitle": "Urus langganan anda dan lihat sejarah pembayaran.",
    "subscription_aria": "Status langganan",
    "subscriptionTitle": "Langganan",
    "loading_aria": "Memuatkan maklumat pengebilan",
    "planPro": "Rhemn Pro",
    "planFree": "Rhemn Percuma",
    "statusLabels": {
      "active": "Aktif",
      "trialing": "Percubaan percuma",
      "past_due": "Tertunggak",
      "unpaid": "Belum dibayar",
      "canceled": "Dibatalkan",
      "incomplete": "Tidak lengkap",
      "none": "Tiada langganan"
    },
    "planValues": {
      "proYearly": "Pro · Tahunan",
      "proMonthly": "Pro · Bulanan"
    },
    "warnings": {
      "paymentFailedTitle": "Pembayaran gagal",
      "paymentFailedDesc": "Pembayaran terakhir anda tidak berjaya. Kemas kini kaedah pembayaran anda melalui Urus Pengebilan untuk mengekalkan akses Pro.",
      "trialEndingTitle": "Percubaan hampir tamat",
      "trialEndingToday": "Percubaan percuma anda tamat hari ini pada {{date}}. Tambah kaedah pembayaran untuk mengekalkan ciri Pro anda.",
      "trialEndingInDays_one": "Percubaan percuma anda tamat dalam {{count}} hari pada {{date}}. Tambah kaedah pembayaran untuk mengekalkan ciri Pro anda.",
      "trialEndingInDays_other": "Percubaan percuma anda tamat dalam {{count}} hari pada {{date}}. Tambah kaedah pembayaran untuk mengekalkan ciri Pro anda."
    },
    "cancellationScheduled": "Pembatalan dijadualkan. Anda mengekalkan akses Pro penuh sehingga <strong>{{date}}</strong>.",
    "sublabel": {
      "trialEndsToday": "Percubaan tamat hari ini",
      "trialDaysRemaining_one": "{{count}} hari berbaki dalam percubaan",
      "trialDaysRemaining_other": "{{count}} hari berbaki dalam percubaan",
      "renews": "Diperbaharui {{date}}",
      "accessUntil": "Akses hingga {{date}}"
    },
    "kv": {
      "status": "Status",
      "nextRenewal": "Pembaharuan seterusnya",
      "trialEnds": "Percubaan tamat",
      "trialDaysLeft_one": "{{count}} hari berbaki",
      "trialDaysLeft_other": "{{count}} hari berbaki",
      "endsToday": "tamat hari ini",
      "plan": "Pelan"
    },
    "upgradeNudge": {
      "title": "Buka ciri Pro",
      "desc": "Cuaca, waktu solat, renungan ayat AI dan banyak lagi — $4.99/bulan atau $39.99/tahun.",
      "cta": "Naik taraf"
    },
    "actions": {
      "manageBilling": "Urus pengebilan & kaedah pembayaran",
      "cancelConfirmTitle": "Batalkan langganan anda?",
      "cancelConfirmDesc": "Anda akan mengekalkan akses Pro penuh hingga akhir tempoh pengebilan semasa anda. Tiada bayaran balik separa dikeluarkan.",
      "canceling": "Membatalkan…",
      "yesCancel": "Ya, batalkan",
      "keepPro": "Kekalkan Pro",
      "cancelSubscription": "Batalkan langganan"
    },
    "noSubscription": "Tiada langganan ditemui.",
    "paymentHistory_aria": "Sejarah pembayaran",
    "paymentHistoryTitle": "Sejarah pembayaran",
    "invoices_aria": "Invois",
    "invoiceView": "Lihat",
    "invoiceView_aria": "Lihat invois dari {{date}}",
    "noInvoices": "Belum ada invois.",
    "dangerZone_aria": "Zon bahaya",
    "dangerZoneTitle": "Zon bahaya",
    "deleteAccountTitle": "Padam akaun",
    "deleteAccountDesc": "Padam akaun anda dan semua data berkaitan secara kekal — tugasan, nota, kegemaran, dan sejarah pengebilan. Tindakan ini tidak boleh diundurkan.",
    "deleteAccountBtn": "Padam akaun",
    "deleteConfirm": {
      "warning": "Ini akan dengan serta-merta dan kekal:",
      "list": {
        "deleteContent": "Padam semua tugasan, nota, dan ayat kegemaran anda",
        "cancelSubscription": "Batalkan sebarang langganan aktif (tiada bayaran balik untuk masa yang tidak digunakan)",
        "removeAccount": "Buang akaun anda daripada pangkalan data kami",
        "signOut": "Log keluar anda daripada semua peranti"
      },
      "typeToConfirm": "Taip <strong>DELETE</strong> untuk mengesahkan",
      "inputPlaceholder": "DELETE",
      "deleting": "Memadam…",
      "confirmBtn": "Padam akaun saya secara kekal",
      "cancelBtn": "Batal"
    },
    "errors": {
      "loadFailed": "Gagal memuatkan maklumat pengebilan.",
      "cancelFailed": "Gagal membatalkan langganan.",
      "deleteFailed": "Gagal memadam akaun. Sila cuba lagi atau hubungi sokongan.",
      "portalFailed": "Gagal membuka portal pengebilan."
    }
  },
  "privacy": {
    "tocLabel": "Dasar Privasi",
    "toc_aria": "Jadual kandungan",
    "lastUpdated": "Dikemas kini terakhir<br />22 September 2026",
    "sections": {
      "overview": "Gambaran Keseluruhan",
      "informationWeCollect": "Maklumat Yang Kami Kumpul",
      "connectedServices": "Perkhidmatan Yang Disambungkan (Google, Todoist, Apple)",
      "howWeUse": "Cara Kami Menggunakan Maklumat Anda",
      "howWeShare": "Cara Kami Berkongsi Maklumat Anda",
      "dataRetention": "Pengekalan Data",
      "yourRights": "Hak Privasi Anda",
      "california": "Penduduk California (CCPA/CPRA)",
      "cookies": "Kuki & Storan Setempat",
      "security": "Keselamatan Data",
      "changes": "Perubahan kepada Dasar Ini",
      "contact": "Hubungi Kami"
    },
    "headings": {
      "informationWeCollect": "Maklumat Yang Kami Kumpul",
      "connectedServices": "Perkhidmatan Yang Disambungkan (Google, Todoist, Apple)",
      "howWeUse": "Cara Kami Menggunakan Maklumat Anda",
      "howWeShare": "Cara Kami Berkongsi Maklumat Anda",
      "dataRetention": "Pengekalan Data",
      "yourRights": "Hak Privasi Anda",
      "california": "Penduduk California (CCPA / CPRA)",
      "cookies": "Kuki & Storan Setempat",
      "security": "Keselamatan Data",
      "changes": "Perubahan kepada Dasar Ini",
      "contact": "Hubungi Kami"
    }
  },
  "deleteAccount": {
    "intro": "Memadam akaun anda akan membuang secara kekal:",
    "list": {
      "account": "Akaun dan profil anda",
      "tasks": "Semua tugasan",
      "notes": "Semua nota",
      "verses": "Ayat disimpan",
      "billing": "Rekod langganan"
    },
    "irreversible": "Tindakan ini tidak boleh dibatalkan.",
    "appleNotice": "Memadam akaun tidak membatalkan langganan yang dibeli melalui App Store. Sila batalkan juga di Tetapan → Apple ID → Langganan.",
    "manageSubscription": "Urus langganan",
    "continueBtn": "Teruskan pemadaman",
    "keepBtn": "Kekalkan akaun saya",
    "confirmTitle": "Padam akaun anda?",
    "confirmDesc": "Akaun anda dan semua datanya akan dipadam secara kekal. Tindakan ini tidak boleh dibatalkan.",
    "confirmBtn": "Padam akaun saya secara kekal",
    "deleting": "Memadam…",
    "error": "Kami tidak dapat memadam akaun anda. Sila semak sambungan anda dan cuba lagi."
  }
}
